import { ComponentChildren } from "preact";

import { ArrowRight, Sparks } from "@attaditya/iconoir-preact";
import { Clickable } from "@components/ui/interactive/clickable";
import { Container } from "@components/ui/structure/container";
import { useClasses } from "@styles";

interface SuggestionButtonProps {
  onClick: () => void;
  children: ComponentChildren;
}

export function SuggestionButton({
  onClick,
  children,
}: SuggestionButtonProps) {
  return (
    <Clickable
      className={useClasses("suggestion-button")}
      onClick={onClick}
    >
      <Container className={useClasses("suggestion-button-icon")}>
        <Sparks />
      </Container>

      <Container className={useClasses("suggestion-button-content")}>
        {children}
      </Container>

      <Container
        className={useClasses("suggestion-button-filler")}
        children={null}
      />

      <Container className={useClasses("suggestion-button-continue-icon")}>
        <ArrowRight />
      </Container>
    </Clickable>
  );
}

